import React, { Component } from 'react';
import WorkContainer from '../../containers/Work';
import { textContainer } from '../../styles';

class NotFound extends Component {
  render() {
    return [
      <div {...textContainer} key="sadface">
        <h1>Sorry, that page doesn't exist. :(</h1>
        <p>Maybe you want to see some of my projects?</p>
      </div>,
      <WorkContainer key="work-container" />,
    ];
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js